export const appEditIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path fill="currentColor" d="M4 16.667V20h3.333l9.83-9.83-3.333-3.333L4 16.667zm15.74-9.074c.347-.347.347-.907 0-1.253l-2.08-2.08c-.346-.347-.906-.347-1.253 0l-1.626 1.626 3.333 3.333 1.626-1.626z"/></g></svg>`,
    name: 'edit' as const
};